import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Action, Store } from "@ngrx/store";
import { Actions } from "@ngrx/effects";
import { Subscription } from "rxjs/Subscription";
// import { CompleterService, CompleterData, CompleterItem } from 'ng2-completer';

import { AppState } from "@store/app-state";
import { EventsStore } from "@store/events";

import { Event } from "@models/event";
import { Ticket } from "@models/ticket";
import { TicketAllocation } from "@models/ticket-allocation";

import {
  PURCHASED_TICKETS_AS_GUEST,
  PURCHASED_TICKETS_AS_EXISTING
} from "@reducers/events";

declare var ga: Function;

@Component({
  selector: 'purchase-ticket',
  templateUrl: './purchase-ticket.pug',
})
export class PurchaseTicketComponent implements OnInit, OnDestroy {

  public event: Event
  public events: Event[]
  // public eventsSearch: string // placholder for the dropdown
  // public eventsCompleter: CompleterData
  public eventsSubscription: Subscription
  public actionsSubcription: Subscription
  public uiState: any = { step: 1 }

  constructor(
    private store: Store<AppState>,
    private actions: Actions,
    private router: Router,
    // private completerService: CompleterService,
  ) {}

  ngOnInit() {
    this.eventsSubscription =
      this.store.select("eventsReducer").subscribe((s: EventsStore) => {
        this.event = s.activeEvent
        this.events = s.events

        // if (s.events.length > 0) {
        //   this.eventsSearch = this.event.title
        //   this.eventsCompleter = this.completerService.local(s.events, null, 'title')
        // }
      })

    if (window['ga']) {
      ga('send', 'event', 'Events Enrolment', this.event.title, 'Select Ticket', {
        nonInteraction: true
      });
    }

    this.actionsSubcription =
      this.actions
        .filter((a: Action) => {
          return [
            PURCHASED_TICKETS_AS_GUEST,
            PURCHASED_TICKETS_AS_EXISTING,
          ].includes(a.type)
        })
        .subscribe((a: Action) => {
          if (window['ga']) {
            ga('send', 'event', 'Events Enrolment', this.event.title, 'Confirmation', {
              nonInteraction: true
            });

            this.selectedTicketTitles().forEach((title: string) => {
              ga('send', 'event', 'Events Enrolled', this.event.title, title, {
                nonInteraction: true
              });
            });
          }

          this.uiState.step = 3
          this.uiState.tickets = a.payload
        })
  }

  clickedTicketAllocation(ta: TicketAllocation) {
    if (ta.available()) {
      ta.uiState.isPurchasing = !ta.uiState.isPurchasing
    }
  }

  clickedCheckboxDirectly(e: MouseEvent) {
    e.preventDefault()
  }

  clickedNext() {
    if (this.purchasingCount() == 0) { return }

    if (window['ga']) {
      ga('send', 'event', 'Events Enrolment', this.event.title, 'Details and Pay', {
        nonInteraction: true
      });
    }

    this.uiState.step = 2
  }

  clickedBack() {
    this.uiState.step = 1
  }

  // changeEvent(item: CompleterItem) {
  clickEventButton(event: Event) {
    console.log(event)
    this.router.navigate(['public', 'events', event.id])
  }

  selectedTickets(): TicketAllocation[] {
    return this.event.ticketAllocations.filter((ta: TicketAllocation) => {
      return ta.uiState.isPurchasing
    })
  }

  selectedTicketTitles(): string[] {
    return this.selectedTickets().map((ta: TicketAllocation) => {
      return ta.title
    })
  }

  purchasingCount(): number {
    return this.selectedTickets().length
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe()
    this.actionsSubcription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/public/purchase-ticket.ts